import type { FlexStation } from "@core/apis/shared";

export type FlexStationSummary = {
  streetAddress: string | null;
  numberOfSensors: number;
  flexStationId: string | null;
  firstFlexStationUid: string | null;
};

/**
 * Reduce a substation's flexstations to the values shown in the All Properties
 * table / map: first street address, living-air-temperature sensor count, the
 * joined flexstation ids, and the first flexstation uid (used to scope the
 * temperature-averages and target-temperature lookups).
 *
 * Shared by the Platform FlexStation overview and the PropAI org Dashboard, which
 * previously duplicated this reduce.
 */
export function summarizeFlexStations(
  flexStations: FlexStation[] | null | undefined
): FlexStationSummary {
  const flexArray = Array.isArray(flexStations) ? flexStations : [];

  let streetAddress: string | null = null;
  let numberOfSensors = 0;

  for (const flexStation of flexArray) {
    const sensors = Array.isArray(flexStation?.sensors) ? flexStation.sensors : [];
    if (!streetAddress) {
      const withAddress = sensors.find((sensor) => sensor?.street_address?.trim());
      if (withAddress) streetAddress = withAddress.street_address ?? null;
    }
    numberOfSensors += sensors.filter(
      (sensor) => sensor?.sensor_type_technical_name === "living_air_temperature"
    ).length;
  }

  const flexUids = flexArray.map((flexStation) => flexStation?.uid).filter(Boolean) as string[];

  return {
    streetAddress,
    numberOfSensors,
    flexStationId: flexUids.join(", ") || null,
    firstFlexStationUid: flexUids[0] ?? null,
  };
}
